import { v4 as uuidv4 } from 'uuid';

import type { DeviceInfo } from '@/types/auth.types';

const DEVICE_ID_KEY = 'nova_device_id';

let cachedDeviceInfo: DeviceInfo | null = null;

export const getOrCreateDeviceId = (): string => {
  const stored = localStorage.getItem(DEVICE_ID_KEY);
  if (stored) {
    return stored;
  }

  const deviceId = uuidv4();
  localStorage.setItem(DEVICE_ID_KEY, deviceId);
  return deviceId;
};

export const getDeviceInfo = (): DeviceInfo => {
  if (cachedDeviceInfo) {
    return cachedDeviceInfo;
  }

  // The backend verify endpoint currently only accepts mobile-app shaped
  // deviceInfo and rejects real browser values (channel: WEB, etc.).
  // Keep the generated deviceId for uniqueness but send the validated
  // mobile-app payload shape for login and verify.
  cachedDeviceInfo = {
    deviceId: getOrCreateDeviceId(),
    deviceName: "John's iPhone 15",
    channel: 'ANDROID',
    deviceType: 'SMARTPHONE',
    manufacturer: 'Apple',
    model: 'iPhone15,2',
    operatingSystem: 'iOS',
    osVersion: '17.1.2',
    appVersion: '3.4.1',
    browser: 'Chrome',
    browserVersion: '120.0.0.0',
    screenResolution: '1179x2556',
    carrier: 'Jio',
    timezone: 'Asia/Kolkata',
    locale: 'en-IN',
    userAgent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 17_1_2 like Mac OS X)',
    location: 'Mumbai, India',
  };

  return cachedDeviceInfo;
};
